import { memo } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
// Redesign counterpart of the legacy ChatAutoShareHeader (common/components/ChatAutoShareHeader):
// section title + New pill + an info tooltip explaining the auto-share behaviour and its modes.
export const RedesignChatAutoShareHeader = memo(() => (<div className="flex items-center gap-2">
		<span className="text-sm font-bold uppercase tracking-wide text-foreground">Chat Auto-Share</span>
		<span className="rounded-full bg-neon-cyan/15 px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none text-neon-cyan">New</span>
		<TooltipProvider delayDuration={200}>
			<Tooltip>
				<TooltipTrigger asChild>
					<button type="button" aria-label="About chat auto-share" className="flex h-5 w-5 items-center justify-center rounded-full text-muted-foreground transition-colors hover:text-foreground">
						<InfoOutlinedIcon sx={{ fontSize: 16 }}/>
					</button>
				</TooltipTrigger>
				<TooltipContent className="max-w-[280px] text-left">
					When enabled, Dare Drop automatically posts your sharing link as a chat announcement while you
					are live and streaming the sponsored game. Choose Auto to adjust frequency to your live viewer
					count while preventing spam (every 20 to 60 minutes), set a fixed interval of 30 minutes, or
					post after a number of chat messages.
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	</div>));
